module.exports = __webpack_public_path__ + "static/img/item1-top.6cad7c29.png";